import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PendingApproval from "@/pages/PendingApproval";
import Dashboard from "@/pages/Dashboard";
import LayoutMap from "@/pages/LayoutMap";
import Inventory from "@/pages/Inventory";
import Bookings from "@/pages/Bookings";
import AdminUsers from "@/pages/AdminUsers";
import AdminBookings from "@/pages/AdminBookings";
import AdminPlots from "@/pages/AdminPlots";
import AdminAudit from "@/pages/AdminAudit";
import AdminAssignments from "@/pages/AdminAssignments";
import AdminPendingPortions from "@/pages/AdminPendingPortions";
import MyChannelPartners from "@/pages/MyChannelPartners";
import Profile from "@/pages/Profile";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return <Landing />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pending-approval" element={<PendingApproval />} />

            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/map" element={<ProtectedRoute><LayoutMap /></ProtectedRoute>} />
            <Route path="/inventory" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
            <Route path="/bookings" element={<ProtectedRoute roles={["agent"]}><Bookings /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute roles={["admin", "super_admin"]}><AdminUsers /></ProtectedRoute>} />
            <Route path="/admin/bookings" element={<ProtectedRoute roles={["admin", "super_admin"]}><AdminBookings /></ProtectedRoute>} />
            <Route path="/admin/plots" element={<ProtectedRoute roles={["super_admin"]}><AdminPlots /></ProtectedRoute>} />
            <Route path="/admin/audit" element={<ProtectedRoute roles={["admin", "super_admin"]}><AdminAudit /></ProtectedRoute>} />
            <Route path="/admin/assignments" element={<ProtectedRoute roles={["super_admin"]}><AdminAssignments /></ProtectedRoute>} />
            <Route path="/admin/pending-portions" element={<ProtectedRoute roles={["admin", "super_admin"]}><AdminPendingPortions /></ProtectedRoute>} />
            <Route path="/admin/my-channel-partners" element={<ProtectedRoute roles={["admin"]}><MyChannelPartners /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute roles={["admin", "super_admin"]}><Profile /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
